export default __webpack_public_path__ + "static/media/golf.1dc6f1a7.webp";